import {ToastrService} from "ngx-toastr";
import {HttpErrorResponse} from "@angular/common/module.d-CnjH8Dlt";
import {Fitrite365Exception} from "../_models/Fitrite365Exception";
import {FormArray, FormGroup} from "@angular/forms";

export class BaseComponent {
  protected constructor(protected toasterService: ToastrService) {

  }

  protected loading = [];

  public get isLoading() {
    return Object.entries(this.loading).some(o => o[1])
  }

  showErrorToast(response: HttpErrorResponse) {
    let quoteItException = response.error as Fitrite365Exception
    if (!quoteItException) {
      this.toasterService.error('An unhandled exception occurred');
      return;
    }

    this.toasterService.error(quoteItException.description, quoteItException.message);
  }

  showAllFormValidation(form: FormGroup | FormArray) {
    for (let c in form.controls) {
      form.controls[c].markAsDirty();
      if(form.controls[c] instanceof FormArray){
        this.showAllFormValidation(form.controls[c])
      }
    }
  }
}
